import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * Breadcrumb. Chakra's default theme gives BreadcrumbLink its own focus
 * styling (a Chakra-blue square ring) that doesn't inherit from the Link
 * theme, so without this file the design-system halo is wrong on every
 * breadcrumb in the app. Here we anchor:
 *   - link color: indigo for navigable crumbs, plum for the current page
 *   - underline-on-hover (matching Link)
 *   - the standard 3px indigo focus halo + sm radius (matching Button/Input/Link)
 *
 * v3 port notes:
 * - v2's `container`/`link`/`item` parts (plus a v2-only `[aria-current]`
 *   CSS-selector hack for the current-page crumb) become 7 real slots in v3
 *   (`root`/`list`/`item`/`link`/`currentLink`/`separator`/`ellipsis`,
 *   confirmed via the built-in `breadcrumb` recipe). v3 gives the current
 *   page its own dedicated `currentLink` slot (rendered by
 *   `Breadcrumb.CurrentLink`, a non-interactive `<span>`) — styled directly
 *   here instead of the old attribute-selector workaround.
 * - The built-in recipe's default `variant: 'plain'` sets its own
 *   `link`/`currentLink` colors (including a `_hover` color shift) —
 *   restated explicitly below so this app's indigo/plum crumbs aren't
 *   overridden by it.
 */

const breadcrumbTheme = defineSlotRecipe({
  slots: [
    'root',
    'list',
    'item',
    'link',
    'currentLink',
    'separator',
    'ellipsis',
  ],
  base: {
    link: {
      color: 'tIndigo.base',
      textDecoration: 'none',
      borderRadius: 'sm',
      _hover: { textDecoration: 'underline' },
      _focusVisible: {
        boxShadow: 'focus',
        outline: 'none',
        textDecoration: 'underline',
      },
    },
    currentLink: {
      color: 'tPurple.base',
      textDecoration: 'none',
    },
  },
  variants: {
    variant: {
      plain: {
        link: {
          color: 'tIndigo.base',
          _hover: { color: 'tIndigo.base', textDecoration: 'underline' },
        },
        currentLink: { color: 'tPurple.base' },
      },
    },
  },
});

export default breadcrumbTheme;
